<template>
  <PageRender
    :key="currentPage.id"
    :id="currentPage.id"
    :sections="currentPage.section_builders ? currentPage.section_builders : []"
    :global-style="currentPage.global_style ? currentPage.global_style.style : null"
    :route-params="currentPage.routeParams"
    :seo-info="currentPage.seo_info"
  />
  
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import PageRender from './PageRender'
import { setCookie } from '../utils'

export default {
  name: 'PageRouter',
  components: {
    PageRender,
  },
  data() {
    return {
      routeParams: {},
      currentPage: {},
    }
  },
  computed: {
    ...mapState({
      permissionInsufficient: state => state.page.permissionInsufficient,
      pages: state => state.page.pages,
      page: state => state.page.page,
    }),
  },
  methods: {
    ...mapActions({
      initData: 'page/initData',
      getPage: 'page/getPage',
    }),
    ...mapMutations({
      setPage: 'page/setPage',
      setPermissionInsufficient: 'page/setPermissionInsufficient',
    }),
    getMatchPath($route) {
      if ($route.name === 'PageRouterRoot' || !$route.matched[0] || !$route.matched[0].path) {
        return '/'
      } else {
        return $route.matched[0].path.replace('/page-preview', '')
      }
    },
    setupCurrentPage() {
      const currentPage = this.page
      currentPage.routeParams = {
        ...this.$route.params,
        ...this.$route.query,
      }
      this.currentPage = currentPage
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    this.getPage(this.getMatchPath(this.$route)).then(() => {
      this.setupCurrentPage()
    })
  },
  destroyed() {
    this.routeParams = {}
  },
  watch:{
    permissionInsufficient: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          const requestHref = this.$router.resolve({
            ruote: this.$route,
            query: this.$route.query,
          }).href

          setCookie('request_href', requestHref, 1)

          this.$router.replace({
            name: '註冊',
          })
        }
      },
    },
    $route (to){
      if (to) {
        this.routeParams = {
          ...to.params,
          ...to.query,
        }
        this.getPage(this.getMatchPath(to)).then(() => {
          this.setupCurrentPage()
        })
      }
    },
  },
}
</script>